import { FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { ChangeEvent, useState } from "react";
import { useAuthContext } from "../../Auth";
import { AutoCompleteUser } from "../../components/UI/AutoCompleteUser";
import { TDialogResult } from "../../dialogs/DialogCookieBanner";
import { DialogPrompResult, DialogPrompt } from "../../dialogs/DialogPrompt";
import { DBUser, UserRole } from "../../ostertalertypes";
import { useStepperContext } from "./StepperContext";

export const StepSelectUser: React.FC = () => {
  const stepperCtx = useStepperContext();
  const authCtx = useAuthContext();

  const [errorFirstname, setErrorFirstname] = useState<string | undefined>(undefined);
  const [errorLastname, setErrorLastname] = useState<string | undefined>(undefined);

  const onUserSelected = (selection: DBUser | null) => {
    if (selection) {
      stepperCtx.setSelectedUser(selection);
    }
  }

  function onFirstnameChange(event: ChangeEvent<HTMLInputElement>) {
    const firstname: string = event.currentTarget.value.trim();
    if (firstname.length === 0) {
      setErrorFirstname("Vorname darf nicht leer sein.");
    } else {
      setErrorFirstname(undefined);
    }
    const lastname = stepperCtx.selectedUser? stepperCtx.selectedUser.lastname: "";
    stepperCtx.setSelectedUser({userid:"", firstname: firstname, lastname: lastname, role: UserRole.ANONYM, bookingCount: 0});
  }

  function onLastnameChange(event: ChangeEvent<HTMLInputElement>) {
    const lastname: string = event.currentTarget.value.trim();
    if (lastname.length === 0) {
      setErrorLastname("Nachname darf nicht leer sein.");
    } else {
      setErrorLastname(undefined);
    }
    const firstname = stepperCtx.selectedUser? stepperCtx.selectedUser.firstname: "";
    stepperCtx.setSelectedUser({userid:"", firstname: firstname , lastname: lastname, role: UserRole.ANONYM, bookingCount: 0});
  }

  function onUserTypeChange(event: React.ChangeEvent<HTMLInputElement>, value: string) {
    stepperCtx.setSelectedUser(null);
    stepperCtx.setUserType(Number(value));
  }

  const onPromptClose = async (result: number) => {
    if (result === DialogPrompResult.YES) {
      stepperCtx.setActiveStep((step) => step + 1);
    }
    stepperCtx.setDialogOpen(false);
  }

  return (
    <>
      <FormLabel>Auswahl Gast</FormLabel>
      <RadioGroup className="mb-5"
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={stepperCtx.userType}
        onChange={onUserTypeChange}
      >
        <FormControlLabel value={UserRole.NORMAL_ACCOUNT} control={<Radio />} label="Auswahl bestehender Gast" />
        <FormControlLabel value={UserRole.ANONYM} control={<Radio />} label="Erstelle neuen Gast ohne E-Mailadresse" />
      </RadioGroup>

      {stepperCtx.userType === UserRole.NORMAL_ACCOUNT && <AutoCompleteUser users={authCtx.allUsers} selectedUser={stepperCtx.selectedUser} onUserSelected={onUserSelected}></AutoCompleteUser>}
      {stepperCtx.userType === UserRole.ANONYM &&
      <>
        <TextField
         className="w-full mb-3"
         onChange={onFirstnameChange}
         helperText={errorFirstname}
         error={errorFirstname ? true : false}
         value={stepperCtx.selectedUser?.firstname || ""}
         id="inputFirstName"
         label="Vorname"
         type="text" />
        <TextField
         className="w-full mb-3"
         onChange={onLastnameChange}
         helperText={errorLastname}
         error={errorLastname ? true : false}
         value={stepperCtx.selectedUser?.lastname || ""}
         id="inputLastName"
         label="Nachname"
         type="text" />
      </>
      }
      <DialogPrompt open={stepperCtx.dialogOpen} onClose={onPromptClose} caption="Benutzer nochmals anlegen?" text={`Sind Sie sicher, dass sie den Benutzer
      ${stepperCtx.selectedUser?.firstname} ${stepperCtx.selectedUser?.lastname} nochmals anlegen möchten? Im Regelfall bitte den existierenden Benutzer auswählen.`}/>
    </>
  );
};